import { Mail, Phone, MapPin, Facebook, Instagram, Star, Heart } from "lucide-react";
import { LOGO_URL } from "@/lib/api";
import { scrollToId } from "@/components/landing/Header";

export const Footer = () => (
  <footer id="contact" data-testid="site-footer" className="relative bg-emerald-800 text-yellow-50 pt-16 pb-8 overflow-hidden">
    <Star className="absolute top-10 left-[8%] w-12 h-12 text-yellow-400/80 animate-float" fill="#FFD93D" />
    <Heart className="absolute bottom-24 right-[10%] w-10 h-10 text-pink-400/80 animate-wiggle" fill="#f472b6" />

    <div className="max-w-6xl mx-auto px-6 relative z-10">
      <div className="text-center mb-12">
        <h2 className="font-display font-bold text-4xl sm:text-5xl text-yellow-300">Adventure Awaits!</h2>
        <p className="font-display font-semibold text-lg mt-2 text-yellow-50">
          A place where kids shine and memories are made.
        </p>
        <button
          data-testid="footer-enroll-btn"
          onClick={() => scrollToId("enroll")}
          className="mt-6 bg-yellow-400 text-emerald-900 font-display font-bold text-lg px-10 py-4 rounded-full hover:bg-yellow-300 hover:scale-105 transition-all"
        >
          Enroll Today!
        </button>
      </div>

      <div className="grid sm:grid-cols-3 gap-8 items-center border-t border-emerald-600 pt-10">
        <div className="flex items-center gap-3 justify-center sm:justify-start">
          <img src={LOGO_URL} alt="WonderStarzLV logo" className="h-16 w-16 object-contain" />
          <span className="font-display font-bold text-xl text-pink-300">
            WonderStarz<span className="text-yellow-300">LV</span>
          </span>
        </div>

        <div className="space-y-2 text-center">
          <a data-testid="footer-email" href="mailto:Info@Wonderstarzlv.com" className="flex items-center gap-2 justify-center hover:text-yellow-300 transition">
            <Mail className="w-4 h-4" /> Info@Wonderstarzlv.com
          </a>
          <a data-testid="footer-phone" href="tel:+17738918466" className="flex items-center gap-2 justify-center hover:text-yellow-300 transition">
            <Phone className="w-4 h-4" /> 773-891-8466
          </a>
          <p className="flex items-center gap-2 justify-center">
            <MapPin className="w-4 h-4" /> Las Vegas, NV
          </p>
        </div>

        <div className="flex gap-4 justify-center sm:justify-end">
          <a href="#" aria-label="Facebook" data-testid="social-facebook" className="w-11 h-11 rounded-full bg-emerald-700 hover:bg-pink-500 flex items-center justify-center transition">
            <Facebook className="w-5 h-5" />
          </a>
          <a href="#" aria-label="Instagram" data-testid="social-instagram" className="w-11 h-11 rounded-full bg-emerald-700 hover:bg-pink-500 flex items-center justify-center transition">
            <Instagram className="w-5 h-5" />
          </a>
        </div>
      </div>

      <p className="text-center text-yellow-100/70 text-sm mt-10">
        © {new Date().getFullYear()} WonderStarzLV. All rights reserved.
      </p>
    </div>
  </footer>
);
